import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function passwordValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const isValid = hasMinLength() && hasNumber() && hasUpper() && hasLower();
    return isValid ? null : { password: true };

    function hasMinLength() {
      return (control.value?.length ?? 0) >= 8;
    }

    function hasNumber() {
      return /\d/.test(control.value);
    }

    function hasUpper() {
      return /[A-Z]/.test(control.value);
    }

    function hasLower() {
      return /[a-z]/.test(control.value);
    }
  };
}
